export const MessagingDataType = Object.freeze({
    InitialData: "InitialData",
    UserMessage: "UserMessage",
    AIResponse: "AIResponse",
});